import { createRouter, createWebHistory } from 'vue-router'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('../views/HomeView.vue')
    },
    {
      path: '/search',
      name: 'search',
      component: () => import('../views/SearchResultsView.vue')
    },
    {
      path: '/venues',
      name: 'venues',
      component: () => import('../views/VenuesView.vue')
    },
    {
      path: '/venues/:id',
      name: 'venue-details',
      component: () => import('../views/VenueDetailsView.vue')
    },
    {
      path: '/venues/:id/map',
      name: 'venue-map',
      component: () => import('../views/VenueMapView.vue')
    },
    {
      path: '/places/:city',
      name: 'places',
      component: () => import('../views/PlacesView.vue')
    },
    {
      path: '/about',
      name: 'about',
      component: () => import('../views/AboutView.vue')
    },
    {
      path: '/contact',
      name: 'contact',
      component: () => import('../views/ContactView.vue')
    },
    {
      path: '/faq',
      name: 'faq',
      component: () => import('../views/FAQView.vue')
    },
    {
      path: '/terms-privacy',
      name: 'terms',
      component: () => import('../views/TermsAndPrivacyView.vue')
    },
    {
      path: '/locations',
      name: 'locations',
      component: () => import('../views/LocationsView.vue')
    }
  ]
})

export default router 